import React, { ReactElement } from 'react';

import { classNames } from 'utils/css';

import { TContentProps } from './Content.types';
import styles from './Content.module.scss';

function Content({
  beforeContent,
  fullWidth,
  children,
  autoHeight,
  hasAfterContent,
  className,
}: TContentProps): ReactElement {
  return (
    <div
      className={classNames(
        styles.root,
        hasAfterContent && styles.withAfter,
        className
      )}
      data-testid="ContentWrapper">
      {beforeContent}
      <div
        className={classNames(
          !fullWidth && styles.gutter,
          (beforeContent || autoHeight) && styles.autoHeight
        )}
        data-testid="Content">
        {children}
        <div className={styles.divider} />
      </div>
    </div>
  );
}

export default Content;
